import * as React from 'react';

import './index.scss';

interface propTypes {
    productLogisticsMode: any[];
    i18n: any;
}
export default function Index ( props: propTypes ) {
    const { productLogisticsMode,i18n } = props;

    if ( Array.isArray( productLogisticsMode ) === false ) return null;
    const renderItem = ( item: string ) => {
        return <li key={item} className="ship-item">{i18n[`mainaction.shipping.${item}`]}</li>;
    };

    return (
        <div className="product-ship">
            <div className="ship-label">{i18n["logistics.title"]}</div>
            <div className="ship-list">
                <ul>
                    {productLogisticsMode.map( item => renderItem( item ) )}
                </ul>
            </div>
        </div>
    );
}
